// Convex client for the web app.
//
// Phase 1 status: SCAFFOLDING. The ConvexAuthProvider is mounted in
// main.tsx but lib/featureFlags.ts' useConvexAuth() returns false in
// every code path, so lib/api.ts continues to route auth through the
// Go backend. When Phase 2 unblocks the cutover (profile/ratings/etc
// moved to Convex so Convex-issued sessions can actually serve real
// requests), flipping the helper is the only change needed here.
//
// Why now? Reactive Convex queries (Phase 2's first beneficiary)
// need a client mounted at the React tree root anyway. Mounting it
// early lets us smoke-test bundle integration without risking the
// auth swap.

import { ConvexReactClient } from "convex/react";

const CONVEX_URL =
  (import.meta as ImportMeta & { env: { VITE_CONVEX_URL?: string } }).env
    .VITE_CONVEX_URL ??
  // Fallback for `npm run dev` without local env. Production builds
  // (Cloudflare Pages) inject VITE_CONVEX_URL at build time.
  "https://lovely-sandpiper-137.eu-west-1.convex.cloud";

export const convex = new ConvexReactClient(CONVEX_URL);

// Convex Auth's default storage adapter (localStorage) works fine
// on web — no shim needed. ConvexAuthProvider uses it automatically
// when no `storage` prop is passed.
